'use strict';

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _initCustomNavFlickity = require('../helpers/initCustomNavFlickity');

var _initCustomNavFlickity2 = _interopRequireDefault(_initCustomNavFlickity);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Components

// PDP Slider

document.addEventListener('DOMContentLoaded', function (event) {
  var featureSliders = document.querySelectorAll('.feature-slider__container');

  [].concat((0, _toConsumableArray3.default)(featureSliders)).forEach(function (slider) {
    // Initialize the slider
    var sliderFlickity = (0, _initCustomNavFlickity2.default)(slider, {
      autoPlay: true,
      prevNextButtons: false,
      pageDots: false,
      fade: true,
      imagesLoaded: true,
      adaptiveHeight: true
    });
  });
}); /*----------------------------
    Scripts
    ----------------------------*/

// Helpers